import React, { useEffect, useState } from 'react';
import { Button, Flex, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { useGetAutoReplyByDid } from '../../hooks/apis/auto_reply_rules.api';
import { RootState } from '../../store/store';
import { AutoReplyRule } from '../../store/slices/auto_reply_rule';
import AutoReplyRuleForm from '../Form/AutoReplyRule';
import Loader from '../generic/Loader';

const { Title } = Typography;

const spinStyle: React.CSSProperties = {
  width: '100%',
  height: 'calc(100% - 80px)',
};

interface AddAutoReplyRulesProps {
  did: string;
}

const AddAutoReplyRules: React.FC<AddAutoReplyRulesProps> = ({ did }) => {
  const { data: rulesData } = useSelector((state: RootState) => state.autoReplyRules);

  const [rules, setRules] = useState<AutoReplyRule[]>(rulesData.filter(rule => rule.did === did));

  const { isLoading: autoReplyLoading } = useGetAutoReplyByDid(did);

  useEffect(() => {
    setRules(rulesData.filter(rule => rule.did === did));
  }, [did, rulesData]);

  const removeRuleByIndex = (index: number) => {
    setRules(prevRules => prevRules.filter((_, i) => i !== index));
  };

  const handleAddRule = () => {
    setRules(prevRules => [
      ...prevRules,
      {
        did,
        rule: {
          conditions: [],
          label: '',
        },
        enabled: true,
        id: '',
        position: 0,
        template: '',
      },
    ]);
  };

  return (
    <div style={{ padding: '10px', height: '100%' }}>
      <Flex justify="space-between">
        <Title>Auto Reply Rules</Title>
      </Flex>
      {autoReplyLoading ? (
        <Flex style={spinStyle} justify="center" align="center">
          <Loader />
        </Flex>
      ) : (
        rules.map((rule, index) => (
          <AutoReplyRuleForm
            key={rule.id || index}
            rule={rule}
            index={index}
            removeRule={removeRuleByIndex}
          />
        ))
      )}
      {!autoReplyLoading && (
        <Button type="dashed" onClick={handleAddRule} block>
          + Add Rule
        </Button>
      )}
    </div>
  );
};

export default AddAutoReplyRules;
